<template>
  <div>
    <b-card
      id="page"
      :border-variant="color"
      class="unbold printarea notifications"
    >
      <div slot="header">
        <b-row align-v="center">
          <b-col cols="10">
            <div v-if="form.state == 0" class="text-danger bold font-2x">
              VOID TRANSACTION
            </div>
            <div v-if="form.state == 1" class="text-success bold font-2x">
              PAID TRANSACTION
            </div>
            <div v-if="form.state == 2" class="text-warning bold font-2x">
              PENDING TRANSACTION
            </div>
          </b-col>
          <b-col cols="2">
            <div class="float-right ml-1 print">
              <b-button
                variant="outline-primary"
                size="sm"
                v-print="'#page'"
                class="ml-1"
              >
                <i class="fa fa-print"></i>
              </b-button>
              <b-button
                class="ml-1"
                variant="outline-primary"
                size="sm"
                @click="Discard()"
              >
                <i class="fa fa-compress"></i>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-card-text>
        <!--    <div class="printheader">
          <div>
            <img src="/img/logo.png" alt />
          </div>
          <strong>RE: {{form.name}}</strong>
          <br />
          <br />
        </div>-->
        <div v-if="receipt">
          <!--   <div v-for="(key,index) in receipt" :key="index">
            <span>{{index}}: {{key}}</span>
          </div>-->
          <div class="receipt">
            <div>
              <b-row class="text-center">
                <b-col>
                  <b-img
                    :src="merchant['companylogo']"
                    :alt="merchant['name']"
                    height="47"
                  ></b-img>
                </b-col>
              </b-row>
              <b-row class="text-center">
                <b-col>{{ merchant["name"] }}</b-col>
              </b-row>
              <b-row class="text-center">
                <b-col
                  >{{ merchant["address1"] }}
                  {{
                    merchant["address2"] ? "," + merchant["address2"] : ""
                  }}</b-col
                >
              </b-row>
              <b-row class="text-center">
                <b-col>{{ merchant["city"] }} {{ merchant["postcode"] }}</b-col>
              </b-row>
              <b-row class="text-center">
                <b-col
                  >{{ merchant["country"] }} {{ merchant["telephone"] }}</b-col
                >
              </b-row>
              <b-row class="mt-4">
                <b-col cols="5">Sale Amount:</b-col>
                <b-col>$ {{ receipt["ssl_amount"] }}</b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="5">Card Number:</b-col>
                <b-col>{{ receipt["ssl_card_number"] }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="5">Date/Time:</b-col>
                <b-col>{{
                  Date.parse(form.refdate).toString(
                    user.dateformat + " " + user.timeformat
                  )
                }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="5">Reference #:</b-col>
                <b-col>{{ receipt["ssl_invoice_number"] }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="5">Auth #:</b-col>
                <b-col>{{ receipt["ssl_approval_code"] }}</b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col>{{ receipt["ssl_card_short_description"] }}</b-col>
              </b-row>
              <b-row class="barcode">
                <!-- <b-col>{{receipt['ssl_txn_id']}}</b-col> -->
                <b-col>
                  <barcode
                    id="barcode"
                    :value="receipt['ssl_txn_id']"
                    :options="barcode_options"
                    :title="receipt['ssl_txn_id']"
                  ></barcode>
                </b-col>
              </b-row>
              <b-row class="my-4 text-center">
                <b-col v-if="form.state == 1" class="text-success bold"
                  >01 APPROVED - THANK YOU</b-col
                >
                <b-col v-else class="text-danger bold"
                  >Transaction not completed</b-col
                >
              </b-row>
            </div>
          </div>
        </div>
        <div v-else>Receipt unavailable</div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import VueBarcode from "@chenfengyuan/vue-barcode";

export default {
  name: "Receipt",
  components: {
    barcode: VueBarcode,
  },
  props: ["selected"],
  data() {
    return {
      receipt: null,
      merchant: null,
      form: {
        id: "",
      },
      barcode_options: {
        // lineColor: '#ff7069',
        fontSize: 54,
        font: "Courier",
        width: 3,
        height: 100,
        marginBottom: 50,
        background: "#f0f3f5",
      },
    };
  },
  watch: {
    selected: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.id = newVal[0].id;
          console.log("watch:selected", newVal);
          this.loadData();
          const merchantCode = this.shortMarinaGroupName;
          this.loadMerchant(merchantCode);
        }
      },
    },
  },
  methods: {
    async loadData() {
      this.text = "Querying...";
      let variables = {
        id: this.id,
      };
      console.log("payments query id: ", variables);
      const response = await this.$apollo.query({
        query: gql`
          query payments($id: String) {
            payments(id: $id) {
              id
              name
              ref
              refdate
              state
              token {
                response
              }
            }
          }
        `,
        variables,
      });
      console.log("payments result", response.data.payments);
      this.form = { ...response.data.payments[0] };
      this.receipt = JSON.parse(this.form.token.response);
    },
    async loadMerchant(code) {
      const response = await this.$apollo.query({
        query: gql`
          query contacts($code: String) {
            contacts(code: $code) {
              name
              code
              companylogo
              address1
              address2
              district
              city
              region
              postcode
              country
              telephone
            }
          }
        `,
        variables: { code },
      });
      this.merchant = response.data.contacts[0];
    },
    Discard() {
      this.$emit("discard");
    },
  },
  computed: {
    ...mapGetters(["user"]),
    shortMarinaGroupName() {
      return this.$store.state.marinaGroupInfo.shortName;
    },
    color() {
      if (this.form.state || this.form.state == 0) {
        switch (this.form.state) {
          case 0:
            return "danger";
          case 1:
            return "success";
          case 2:
            return "warning";
        }
      }
    },
  },
};
</script>

<style>
#barcode {
  width: 275px;
}
</style>
